import { render, staticRenderFns } from "./FSTab.vue?vue&type=template&id=2103130c&scoped=true&"
import script from "./FSTab.vue?vue&type=script&lang=js&"
export * from "./FSTab.vue?vue&type=script&lang=js&"
import style0 from "./FSTab.vue?vue&type=style&index=0&id=2103130c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2103130c",
  null
  
)

export default component.exports